export type ChatProps = {
  onChatClose: () => void
  recipientId: number
  recipientImage: string | null
  recipientName: string
}

export enum MessageAction {
  RECEIVE_MESSAGE = 'receiveMessage',
  SEND_MESSAGE = 'sendMessage',
}

export enum ConnectionState {
  CLOSED = 'closed',
  CONNECTING = 'connecting',
  OPEN = 'open',
  RECONNECTING = 'reconnecting',
}

export type IncomingMessage = {
  content: string
  id: number
}
